<!-- ------------------------------------------------------------------ -->
<!-- Add new contact -->
<!-- ------------------------------------------------------------------ -->
<mat-dialog-content class="mat-typography">
  <div class="d-flex align-items-center justify-content-between m-b-16">
    <h4 class="f-s-16 f-w-600 m-b-16">Add New Contact</h4>
    <button
      mat-icon-button
      mat-dialog-close
      class="d-flex justify-content-center"
    >
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  <form>
    <div class="file-input-container m-b-24 position-relative uploader">
      @if(imageUrl){
      <img
        [src]="imageUrl"
        alt="Selected Image"
        width="100"
        class="rounded upload-image"
      />
      }
      <input type="file" (change)="onFileSelected($event)" accept="image/*" />
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">First Name</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.firstname"
            name="firstname"
            placeholder="First Name"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Last Name</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.lastname"
            name="lastname"
            placeholder="Last Name"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Company Name</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.company"
            name="company"
            placeholder="Company Name"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Phone Number</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.phone"
            name="phone"
            placeholder="Phone Number"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Email</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.email"
            name="email"
            type="email"
            placeholder="Email"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Address</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [(ngModel)]="contact.address"
            name="address"
            placeholder="Address"
          />
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Notes</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <textarea
            matInput
            [(ngModel)]="contact.notes"
            name="notes"
            placeholder="Notes"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Department</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select [(ngModel)]="contact.department" name="department">
            @for(dept of departments; track dept.id) {
            <mat-option [value]="dept.name">{{ dept.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<div mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    (click)="saveContact()"
    [disabled]="!isFormValid()"
  >
    Add Contact
  </button>
  <button mat-flat-button class="bg-error text-white" (click)="cancel()">
    Cancel
  </button>
</div>
